
import { has, prop, ifElse, identity, equals, is, cond, or, where } from 'ramda'
import { hasRoute } from './helpers.routes';
import { isUndefined, renameKey } from 'ramda-adjunct';
import { ScreenProps } from '../_types';
import * as R from 'ramda';

export const toComponent = prop("view");

export const ensureRootieComponent = ifElse(has("view"),toComponent,identity)

export const toRoute = (screen: ScreenProps):any => {
  const {to,...rest} = screen.route;
  const newRoute = {
    Component:ensureRootieComponent(screen),
    components: screen.components,
    path: to,
    ...rest
  }

  return newRoute;
}
export const hasRouteOrId = or(hasRoute,has("routeId"));

export const ensureScreen = ifElse(has("route"),toRoute,identity)

// Ramda function to test if an object is a valid ScreenProps

export const isScreenProps = where({
  cat: equals('screen'), // Assuming cat is a string or similar simple type
  type: R.is(String), // Assuming ViewType is a string or similar simple type
  id: R.either(is(String),R.isNil), // Optional string
  view: R.is(Object), // Simplistic check; could be refined
  route: R.is(Object), // Simplistic check; could be refined
  components: R.either(R.isNil, R.where({ // Optional components object
      layout: R.either(R.isNil, R.is(Object)),
      protected: R.either(R.isNil, R.is(Object)),
      errorBoundary: R.either(R.is(Function), R.isNil),
  }))
});

export const toDynamicRoute = cond([
  [isUndefined, identity as any],
  [ hasRouteOrId, toRoute ],
  [ R.T, identity as any]
])
